import { render } from "./RegionalManagerHome.vue?vue&type=template&id=0ed5f64c"
import script from "./RegionalManagerHome.vue?vue&type=script&lang=js"
export * from "./RegionalManagerHome.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./RegionalManagerHome.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_229a35a3%2Fpackages%2Fstore%2Fsrc%2Fviews%2Fadmin%2Fanalytics%2FRegionalManagerHome.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__